import React, { useCallback, useState } from 'react'
import { Image, Modal, Stack, Text } from '@mantine/core'
import { useLotteryData } from '../../hooks'

interface PrizePreviewProps {}

interface SelectedPrize {
  id: number
  prizeName: string
  prizeImageUrl: string
  prizeDescription?: string
}

const PrizePreview: React.FC<PrizePreviewProps> = () => {
  const { currentLotteryInfo } = useLotteryData()
  const [selectedPrize, setSelectedPrize] = useState<SelectedPrize | null>(null)
  const [showModal, setShowModal] = useState(false)

  const handlePrizeClick = useCallback((prize: any) => {
    setSelectedPrize({
      id: prize.id,
      prizeName: prize.prizeName,
      prizeImageUrl: prize.prizeImageUrl,
      prizeDescription: prize.prizeDescription || '精美奖品等你来拿！',
    })
    setShowModal(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setShowModal(false)
    setSelectedPrize(null)
  }, [])

  return (
    <>
      <style>
        {`
          .prize-scroll-container::-webkit-scrollbar {
            display: none;
          }
          
          .prize-scroll-container {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          
          .prize-item {
            transition: all 0.2s ease;
          }
          
          .prize-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          }
          
          .prize-item:active {
            transform: translateY(0);
          }
          
          /* 隐藏Modal的滚动条 */
          .mantine-Modal-root, 
          .mantine-Modal-inner,
          .mantine-Modal-content,
          .mantine-Modal-body {
            overflow: hidden !important;
          }
          
          /* 确保页面不会滚动 */
          body.mantine-Modal-opened {
            overflow: hidden !important;
          }
          
          /* 移除Modal中Image组件的默认背景 */
          .mantine-Modal-content .mantine-Image-root,
          .mantine-Modal-content .mantine-Image-figure,
          .mantine-Modal-content .mantine-Image-imageWrapper,
          .mantine-Modal-content .mantine-Image-placeholder {
            background-color: transparent !important;
            background: transparent !important;
          }
        `}
      </style>
      <div style={{ marginTop: 16, position: 'relative', display: 'flex', alignItems: 'center' }}>
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Text
            style={{
              color: '#FF5A5A',
              fontWeight: 700,
              fontSize: 18,
              writingMode: 'vertical-rl',
              letterSpacing: 2,
              userSelect: 'none',
            }}
          >
            奖品预览
          </Text>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 12,
            marginLeft: 16,
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            paddingBottom: 8,
            paddingRight: 16,
            width: '100%',
          }}
          className="prize-scroll-container"
        >
          {currentLotteryInfo?.prizes.map((prize) => (
            <div
              key={prize.id}
              onClick={() => handlePrizeClick(prize)}
              className="prize-item"
              style={{
                cursor: 'pointer',
                borderRadius: 8,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                flexShrink: 0,
                minWidth: 98,
              }}
            >
              <Image
                src={prize.prizeImageUrl}
                style={{
                  width: 98,
                  height: 98,
                  objectFit: 'cover',
                  borderRadius: 8,
                  background: '#fff',
                  flexShrink: 0,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <Modal
        opened={showModal}
        onClose={handleCloseModal}
        centered
        withCloseButton={false}
        padding={0}
        zIndex={1100}
        overlayProps={{ opacity: 0.8 }}
        styles={{
          body: {
            padding: 0,
            background: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden',
          },
          content: {
            background: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden',
            maxHeight: '90vh',
          },
          inner: {
            overflow: 'hidden',
          },
        }}
      >
        {selectedPrize && (
          <div
            style={{
              background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
              borderRadius: 16,
              padding: '20px',
              maxWidth: '320px',
              width: '90vw',
              maxHeight: '80vh',
              margin: '0 auto',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
              position: 'relative',
              border: '1px solid rgba(255, 90, 90, 0.1)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: -10,
                right: -10,
                width: 40,
                height: 40,
                background: 'linear-gradient(135deg, #FF5A5A, #FF8E8E)',
                borderRadius: '50%',
                opacity: 0.1,
              }}
            />
            <div
              style={{
                position: 'absolute',
                bottom: -5,
                left: -5,
                width: 30,
                height: 30,
                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                borderRadius: '50%',
                opacity: 0.1,
              }}
            />

            <Stack gap={16} align="center">
              <img
                src={selectedPrize.prizeImageUrl}
                alt={selectedPrize.prizeName}
                style={{
                  maxWidth: '200px',
                  maxHeight: '120px',
                  height: 'auto',
                  width: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                  margin: '0 auto',
                  border: 'none',
                  background: 'none',
                  borderRadius: '8px',
                }}
              />

              <Stack gap={8} align="center">
                <Text
                  size="lg"
                  fw={700}
                  style={{
                    color: '#FF5A5A',
                    textAlign: 'center',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  {selectedPrize.prizeName}
                </Text>

                <Text
                  size="sm"
                  style={{
                    color: '#666',
                    textAlign: 'center',
                    lineHeight: 1.5,
                  }}
                >
                  {selectedPrize.prizeDescription}
                </Text>
              </Stack>

              <div
                onClick={handleCloseModal}
                style={{
                  marginTop: '12px',
                  background: 'linear-gradient(135deg, #FF5A5A, #FF8E8E)',
                  color: 'white',
                  padding: '10px 24px',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: '14px',
                  boxShadow: '0 4px 12px rgba(255, 90, 90, 0.3)',
                  userSelect: 'none',
                  flexShrink: 0,
                  textAlign: 'center',
                }}
              >
                ✨ 知道了
              </div>
            </Stack>
          </div>
        )}
      </Modal>
    </>
  )
}

export default PrizePreview
